<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/K9oGnz/tc-custom/9781429976282.jpg?1721429532222" alt="This image is the cover for the book Murder In Hollywood, St. Martin's True Crime Classics"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Murder In Hollywood, St. Martin's True Crime Classics
      </h1>
      <p class="bookDescription body article font2">
        <p>Her husband was Robert Blake, the award-winning star of <i>In Cold Blood</i>. But she found her own fame at point-blank range...<br/><br/>Obsessed with glamour and wealth, she followed her dream to Hollywood, and finally found fame-- in death.<br/><br/>Bonny Lee Bakley's dream was to marry a movie star. Using sex and guts, the ruthless small-town blonde finally struck it rich by wedding Robert Blake, the Emmy Award-winning actor who scored in the hit show "Baretta." When Blake found his bride of six months with a bullet in her head outside a Los Angeles restaurant, he was thrust back into the spotlight, and Bonny Lee was exposed for the manipulative woman she was-- a grifter with a sordid criminal history of sex swindles, credit-card fraud, and Social Security scams. But her specialty was fleecing wealthy men for quick cash-- a lucrative sting that finally brought Bonny Lee Bakley to Hollywood to live-- and die-- among the rich and famous...<br/><br/>But who really murdered Bonny Lee in cold blood? How did it play into Robert and Bonny's turbulent marriage? Was she a victim of her own con-- or something more sinister? What was the truth behind her fears of being stalked? And what secrets were hidden in Bonny's past that she found impossible to outrun?<br/><br/>Now, in this riveting, fascinating account, Gary C. King brings you the inside details of the most talked-about Tinseltown murder in years.<br/><br/>With 8 pages of unforgettable photos!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gary C. King
      </h2>
      
      <p class="authorDescription body article"><P>For the last twenty years, <B>Gary C. King</B> has been one of America's foremost crime writers. Over 400 of his stories have appeared in crime magazines across the United States, Canada, and England, including <I>True Detective</I>, <I>Official Detective</I>, <I>Inside Detective</I>, <I>Front Page Detective</I>, and <I>Master Detective</I>. His books <I>Web of Deceit</I>,<I> Driven to Kill</I> (which was nominated for an Anthony Award in the Best True Crime Book category at Bouchercon 25) and <I>Blood Lust: Portrait of a Serial Sex Killer </I>were chosen as a featured selection of the True Crime Book Club. He is also the author of <I>Blind Rage</I> and <I>Savage Vengeance</I>, co-written with Don Lasseter. A full-time writer, Mr. King is an active member of the Mystery Writers of America. He lives in Las Vegas, Nevada, with his wife and two daughters.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0f627ac5